import React from "react"
import urlBuilder from "@sanity/image-url"
import { createImageUrlArray } from "../../helperFunctions"
import PhotoAlbum from "./PhotoAlbum"

// An album specifically for portable text
const InlineAlbum = ({ albumData }) => {
  const { albumImages } = albumData
  // use helper function to create an array of image data for react-image-gallery
  const imageUrlArray = createImageUrlArray(albumImages)

  return (
    <div className="flex justify-center">
      <div className="max-w-sm md:max-w-md">
        <h2>{albumData.title}</h2>
        <PhotoAlbum imageUrlArray={imageUrlArray} />
      </div>
    </div>
  )
}

export default InlineAlbum
